import React from 'react';
import styles from '../../styles/Recepti.module.css';

//let data: any;
const ItemRecepti = (props) => {

    let allMeds = props.data // getting UID
    //let ind = props.idata // getting index WHY ??
    // id: key, 
    // date: data[key].date, 
    // med: data[key].med,
    // howM: data[key].howM,
    // manyT: data[key].manyT 

    let showAllMeds = (
        <p>Ni Receptov</p>
    );
        
    if (allMeds) {
        showAllMeds = (
            allMeds.map((each) => (
                <div
                    className={styles.EachRecept}
                    key={each.id}>
                    <div className={styles.EachTop}>
                        <h4>{each.med}</h4>
                        <p>{each.date}</p>
                    </div>
                    <p>{each.howM} x {each.manyT}</p>
                </div>
            ))
        )
    }
    
    return  (
        <div className={styles.Recepti}>
            { showAllMeds }
        </div>
    ) 
}

export default ItemRecepti;
